// Redux slice quản lý phòng ban
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";
import { toast } from "react-toastify";

export const fetchPhongBan = createAsyncThunk("phongBan/fetchPhongBan", async (params = {}, { rejectWithValue }) => {
  try {
    const res = await api.get("/hr.department", {
      params: {
        size: params.size || 100,
        order: "id desc",
        page: params.page || 1,
        search: params.search || undefined,
      },
    });
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const addPhongBan = createAsyncThunk("phongBan/addPhongBan", async (payload, { rejectWithValue }) => {
  try {
    const res = await api.post("/hr.department", payload);
    toast.success("Thêm phòng ban thành công!");
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const updatePhongBan = createAsyncThunk("phongBan/updatePhongBan", async (payload, { rejectWithValue }) => {
  try {
    const res = await api.put(`/hr.department/${payload.id}`, payload);
    toast.success("Cập nhật phòng ban thành công!");
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const deletePhongBan = createAsyncThunk("phongBan/deletePhongBan", async (id, { rejectWithValue }) => {
  try {
    await api.delete(`/hr.department/${id}`);
    toast.success("Xóa phòng ban thành công!");
    return id;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const fetchLoaiPhongBan = createAsyncThunk("phongBan/fetchLoaiPhongBan", async (params = {}, { rejectWithValue }) => {
  try {
    const res = await api.get("/hr.department.type", {
      params: {
        size: params.size || 100,
        order: "id desc",
        page: params.page || 1,
      },
    });
    return res.data?.content || [];
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

const phongBanSlice = createSlice({
  name: "phongBan",
  initialState: {
    items: { content: [], totalElements: 0 },
    loadPhongBans: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPhongBan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPhongBan.fulfilled, (state, action) => {
        state.items = action.payload || [];
        state.loading = false;
      })
      .addCase(fetchPhongBan.rejected, (state) => {
        state.loading = false;
        // state.error = action.payload;
      })
      .addCase(addPhongBan.fulfilled, (state, action) => {
        state.items.content.push(action.payload);
        state.items.totalElements += 1;
      })
      .addCase(updatePhongBan.fulfilled, (state, action) => {
        const idx = state.items.content.findIndex((d) => d.id === action.payload.id);
        if (idx > -1) state.items.content[idx] = { ...state.items.content[idx], ...action.payload };
      })
      .addCase(deletePhongBan.fulfilled, (state, action) => {
        state.items.content = state.items.content?.filter((d) => d.id !== action.payload);
        state.items.totalElements -= 1;
      })
      .addCase(fetchLoaiPhongBan.fulfilled, (state, action) => {
        state.loadPhongBans = action.payload || [];
      });
  },
});

export default phongBanSlice.reducer;
